import { useQueryClient } from '@tanstack/react-query';
import { AUTOMATED_REVIEW_LOGS_BASE_QUERY_KEY } from 'components/domain/review/automatedReviewLogs/automatedReviewLogsQuery';
import { parseISO } from 'date-fns';
import useAppModal from 'hooks/useAppModal';
import useAppMutation from 'hooks/useAppMutation';
import { AutomatedReviewLog } from 'models/automation/Reviews';
import { useTranslation, Trans } from 'react-i18next';
import API from 'services/API';

const useActionCancelAutomatedReviewLog = () => {
  const { openConfirmModal } = useAppModal();
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { mutateAsync } = useAppMutation({
    mutationFn: ({
      automatedReviewLogUid,
    }: {
      automatedReviewLogUid: string;
    }) => {
      return API.post(
        `/api/internal/scheduled-hosts-reviews/${automatedReviewLogUid}/cancel`,
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries([AUTOMATED_REVIEW_LOGS_BASE_QUERY_KEY]);
    },
  });

  const openCancelAutomatedReviewLogModal = ({
    automatedReviewLog,
  }: {
    automatedReviewLog: AutomatedReviewLog;
  }) => {
    openConfirmModal({
      title: t(
        'pageAutomations.reviews.automatedReviewLogs.actions.cancel.title',
      ),
      body: (
        <Trans
          i18nKey="pageAutomations.reviews.automatedReviewLogs.actions.cancel.description"
          values={{
            reviewName: automatedReviewLog.reviewTemplateTitle,
            guestName: automatedReviewLog.guest.name,
            date: parseISO(automatedReviewLog.reviewDate),
          }}
          components={{ br: <br /> }}
        />
      ),
      confirmColor: 'danger',
      confirmLabel: t(
        'pageAutomations.reviews.automatedReviewLogs.actions.cancel.confirm',
      ),
      onConfirmAsync: async () => {
        await mutateAsync({ automatedReviewLogUid: automatedReviewLog.uid });
      },
    });
  };

  return {
    openCancelAutomatedReviewLogModal,
  };
};

export default useActionCancelAutomatedReviewLog;
